module.exports = __webpack_public_path__ + "static/media/time-file.98b186fc.svg";